import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import _ from "lodash";
// import { entryUnit } from "@/service/user";
import { getCodeDict } from "../../service/codeDict";
import { createUnit } from "../../service/unit";
export default {
  data() {
    const h = this.$createElement;
    return {
      scopes: [],
      industries: [],
      createUnitModal: false,
      loading: false,
      data: {},
      columns: [{
        title: $t("auerdn4", "单位名称"),
        key: "unitName",
        rules: [{
          required: true,
          message: $t("icuel18", "单位名称不能为空")
        }, {
          pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{2,60}$/,
          message: $t("m65oshn", "仅支持字母数字汉字部分符号2-60个字符的命名")
        }]
      }, {
        title: $t("aunena4", "单位行业"),
        key: "unitIndustry",
        renderForm: () => {
          var _this$data;
          return h("i-select", {
            "attrs": {
              "value": (_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.unitIndustry
            },
            "on": {
              "on-select": value => {
                this.$set(this.data, "unitIndustry", value.value);
              }
            }
          }, [_.map(this.industries, val => {
            return h("Option", {
              "attrs": {
                "value": val.code
              }
            }, [val.value]);
          })]);
        }
      }, {
        title: $t("aunt6d4", "单位规模"),
        key: "unitScope",
        renderForm: () => {
          var _this$data2;
          return h("i-select", {
            "attrs": {
              "value": (_this$data2 = this.data) === null || _this$data2 === void 0 ? void 0 : _this$data2.unitScope
            },
            "on": {
              "on-select": value => {
                this.$set(this.data, "unitScope", value.value);
              }
            }
          }, [_.map(this.scopes, val => {
            return h("Option", {
              "attrs": {
                "value": val.code
              }
            }, [val.value]);
          })]);
        }
      }]
    };
  },
  methods: {
    ok() {
      this.$refs["proForm"].validate(async val => {
        if (val) {
          this.loading = true;
          const res = await createUnit(this.data);
          if (res.data && res.data.result === 0) {
            this.$Message.success(res.data.msg || $t("h4sv2", "成功"));
            // await entryUnit(res.data.retVal);
            this.$router.push("/login");
            this.createUnitModal = false;
          }
          this.loading = false;
        }
      });
      this.$nextTick(() => {
        this.loadingLog = true;
      });
    },
    cancel() {
      this.loading = false;
      this.data = {};
      this.$refs["proForm"].reset();
      this.createUnitModal = false;
    },
    async join(type) {
      if (type === "has") {
        this.$Message.info($t("9dliaze", "请联系你的单位管理员邀请加入"));
      }
      if (type === "create") {
        this.createUnitModal = true;
        const res = await getCodeDict("UNIT_SCOPE");
        this.scopes = res.data.retVal;
        const res2 = await getCodeDict("UNIT_INDUSTRY");
        this.industries = res2.data.retVal;
      }
    }
  }
};